// extracted by mini-css-extract-plugin
module.exports = {"root":"WebshopLanding_root__3v67n","entrypoints":"WebshopLanding_entrypoints__1RDaU"};